import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './NaturezaJuridica.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const NaturezaJuridicaEdit =

withRouter(

// redux
connect(
	null, 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				naturezaJuridica: {
					id: "",
					codigo: "",
					nome: "",
					esferaAdministrativa: "",
					permiteAutocadastramento: false
				},
				botoesHabilitados : true,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Natureza Jurídica</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
		)}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				api.get('/api/natureza-juridica/' + id)
				.then(response => { 
					const naturezaJuridica = {
						...response.data,
						codigo: String(response.data.id),
						esferaAdministrativa: response.data.esferaAdministrativa ?? 'N'
					};
					this.setState(
						{
							naturezaJuridica
						}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar a natureza jurídica " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}
		}

		renderForm() {
			return(
				<div className="container-fluid">
					<div className="br-form">
								<div className="row">
                                <div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="codigo">Código:</label>
												<input type="text" name="codigo" 
													value={this.state.naturezaJuridica.codigo}  
													onChange={this.handleInputChange} 
													disabled={this.state.naturezaJuridica.id ? true : false}
													maxLength="100"/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="nome">Nome:</label>
												<input type="text" name="nome" 
													value={this.state.naturezaJuridica.nome}  
													onChange={this.handleInputChange} 
													maxLength="100"/>
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
                                            <label htmlFor="esferaAdministrativa">Esfera Administrativa:</label>
											<SelectSearch
												id="esferaAdministrativa"
												name="esferaAdministrativa"
												options={[{ value: "F", label: 'Federal' }, { value: "E", label: 'Estadual' }, { value: "M", label: 'Municipal' }, { value: "N", label: 'Sem Esfera Administrativa' }]}
												onChange={this.handleInputChange}
												value={this.state.naturezaJuridica.esferaAdministrativa}
												disabled={this.state.naturezaJuridica.hasEsferaAdministrativa ? true : false}
											/>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-sm-4">
										<div className="field">
											<div className="input">
												<label htmlFor="permiteAutocadastramento">Permitida no Autocadastramento de Usuários/Órgãos:</label>
												<SelectSearch
													id="permiteAutocadastramento"
													name="permiteAutocadastramento"
													options={[{value: true, label: 'Sim'}, {value: false, label: 'Não'}]}
													onChange={this.handleInputChange}
													value={this.state.naturezaJuridica.permiteAutocadastramento}
												/>
											</div>
										</div>
									</div>
								</div>
						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>{this.state.naturezaJuridica.id ? 'Alterar' : 'Incluir'}</button>
								{this.state.naturezaJuridica.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Natureza Jurídica</button>
								}
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const naturezaJuridica = this.state.naturezaJuridica;
			naturezaJuridica[nome] = valor;
			this.setState({ naturezaJuridica });
		}

		// handlePermiteAutocadastramentoChange(valor){
		// 	const permiteAutocadastramento =  evento.target.value === true;

		// 	this.setState({
		// 		aplicacaoFornecedora
		// 	});
		// }

		novo(e){
			const rotaParaNovo = "/natureza-juridica/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				console.log(erroValidacao)
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados:false});
			const naturezaJuridica = this.state.naturezaJuridica;

			const method = naturezaJuridica.id ? 'put' : 'post';

			let url = "/api/natureza-juridica";
			if(naturezaJuridica.id){
				url = url + '/' + naturezaJuridica.id;
			}

			const data = {
				id: naturezaJuridica.codigo,
				nome: naturezaJuridica.nome,
				esferaAdministrativa: naturezaJuridica.esferaAdministrativa === "N" ? null : naturezaJuridica.esferaAdministrativa,
				permiteAutocadastramento: naturezaJuridica.permiteAutocadastramento
			}
			
			const options = {
				method,
				url,
				"data": data
			}

			api(options)
				.then(response => {
					const mensagem = `Natureza Jurídica ${this.state.naturezaJuridica.id ? 'alterada' : 'incluída'} com sucesso!`;
					this.setState({ 
						naturezaJuridica: {
							...response.data,
							codigo: response.data.id.toString(),
							esferaAdministrativa: response.data.esferaAdministrativa === null ? "N" : response.data.esferaAdministrativa
						 },
					}, () => {console.log("DA API", this.state.naturezaJuridica)});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.naturezaJuridica.id ? 'alterar' : 'incluir'} a natureza jurídica.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
				});   
		}

		validaFormulario(){
			let mensagens = [];
			const {codigo, nome, esferaAdministrativa } = this.state.naturezaJuridica;

			if(!codigo || codigo.trim().length === 0 ){
				mensagens.push({mensagem: "Código é obrigatório."})
			}
			

			if(!nome || nome.trim().length === 0 ){
				mensagens.push({mensagem: "Nome é obrigatório."})
			}

			if(!esferaAdministrativa || !esferaAdministrativa.trim().length === 0 ){
				mensagens.push({mensagem: "Esfera Administrativa é obrigatória."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

	}

) // redux
); // router